document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-modal]');
  if (trigger) {
    e.preventDefault();
    const modal = document.getElementById(trigger.dataset.modal);
    if (modal) {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    return;
  }

  const close = e.target.closest('[data-modal-close]');
  if (close) {
    const modal = close.closest('.modal');
    if (modal) closeModal(modal);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const modal = document.querySelector('.modal.is-active');
    if (modal) closeModal(modal);
  }
});

function closeModal(modal) {
  modal.classList.remove('is-active');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
